import { render, staticRenderFns } from "./KFileField.vue?vue&type=template&id=87b577b0&scoped=true"
import script from "./KFileField.vue?vue&type=script&lang=js"
export * from "./KFileField.vue?vue&type=script&lang=js"
import style0 from "./KFileField.vue?vue&type=style&index=0&id=87b577b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b577b0",
  null
  
)

export default component.exports